var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZinihubIconRoundEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "413.047 608.343 852.789 852.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #7fb241;\n      }\n\n      .st1 {\n        fill: #f0f8f4;\n      }\n\n      .st2 {\n        fill: #fab27b;\n      }\n\n      .st3 {\n        fill: #549542;\n      }\n\n      .st4 {\n        fill: #0e1e2d;\n      }\n\n      .st5 {\n        fill: #243745;\n      }\n\n      .st6 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st8 {\n        fill: #62a844;\n      }\n\n      .st9 {\n        fill: #fffcf5;\n      }\n\n      .st10 {\n        fill: #181516;\n      }\n\n      .st11 {\n        fill: #07a3a1;\n      }\n\n      .st12 {\n        fill: #fdd262;\n      }\n\n      .st13 {\n        fill: #f09b20;\n      }\n\n      .st14 {\n        fill: #d0562a;\n      }\n\n      .st15 {\n        fill: #f89b57;\n      }\n\n      .st16 {\n        fill: #d04843;\n      }\n\n      .st17 {\n        fill: #f7a166;\n      }\n\n      .st18 {\n        fill: #ea6834;\n      }\n\n      .st19 {\n        fill: url(#linear-gradient);\n      }\n\n      .st20 {\n        fill: #0c6e7d;\n      }\n\n      .st21 {\n        fill: #f9f7f4;\n      }\n\n      .st22 {\n        fill: #d8d8d8;\n      }\n\n      .st23 {\n        fill: #2fbebc;\n      }\n\n      .st24 {\n        fill: #fffbf6;\n      }\n\n      .st25 {\n        fill: #f36d53;\n      }\n\n      .st26 {\n        fill: #65a042;\n      }\n\n      .st27 {\n        fill: #079d9b;\n      }\n\n      .st28 {\n        fill: #dd5047;\n      }\n\n      .st29 {\n        fill: #e56429;\n      }\n\n      .st30 {\n        fill: #fafafb;\n      }\n\n      .st31 {\n        fill: #651e16;\n      }\n\n      .st32 {\n        fill: #081f2e;\n      }\n\n      .st33 {\n        fill: #fff;\n      }\n\n      .st34 {\n        fill: #539743;\n      }\n\n      .st35 {\n        fill: #25a289;\n      }\n\n      .st36 {\n        fill: #152d3f;\n      }\n\n      .st37 {\n        fill: #099d97;\n      }\n\n      .st38 {\n        fill: #05929e;\n      }\n\n      .st39 {\n        fill: #c1622a;\n      }\n\n      .st40 {\n        fill: #fefefc;\n      }\n\n      .st41 {\n        fill: #009fa9;\n      }\n\n      .st42 {\n        fill: #f26a50;\n      }\n\n      .st43 {\n        fill: #f89a56;\n      }\n\n      .st44 {\n        fill: #0c2434;\n      }\n\n      .st45 {\n        fill: #f9a05c;\n      }\n\n      .st46 {\n        fill: #0483a0;\n      }\n\n      .st47 {\n        fill: #f1603e;\n      }\n\n      .st48 {\n        fill: #80bc41;\n      }\n\n      .st49 {\n        fill: #7bb242;\n      }\n\n      .st50 {\n        fill: #f8c33b;\n      }\n\n      .st51 {\n        fill: #b46231;\n      }\n\n      .st52 {\n        fill: #fab176;\n      }\n\n      .st53 {\n        fill: #191413;\n      }\n\n      .st54 {\n        fill: #039f9e;\n      }\n\n      .st55 {\n        fill: #fddcc9;\n      }\n\n      .st56 {\n        fill: #ec5c44;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 988.27,
    y1: 1147.14,
    x2: 988.27,
    y2: 859.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a7886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#44b380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2fb38d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 1273.75,
    y1: 1174.57,
    x2: 1273.75,
    y2: 783.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbac25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fdbe35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#febc35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 1050.84,
    y1: 970.96,
    x2: 1211.57,
    y2: 970.96,
    href: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 413.047,
    y: 608.343,
    width: 852.789,
    height: 852.789,
    rx: 80,
    ry: 80
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -147.817034, 96.127473)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M553.97,1222.38l-2.93,3.42c.6-.97,1.3-1.86,2.1-2.65.27-.27.54-.52.83-.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M598.92,1253.36c-.75,1.23-1.64,2.37-2.67,3.39-.37.37-.77.73-1.17,1.08l3.84-4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M925.6,1005.26v120.4h-270.81c-42.66,0-58.6-20.63-61.42-41.27-2.81-20.63,13.24-40.09,13.24-40.09,0,0,179.01-214.52,183.23-220.68,2.85-4.16-.09-7.2-2.28-8.73h-168.29c-21.11,0-38.23-17.11-38.23-38.23,0-10.55,4.27-20.1,11.2-27.02,6.91-6.91,16.47-11.2,27.03-11.2h242.42c21.11,0,38.21,17.11,38.21,38.21,0,1.43-.07,2.84-.24,4.22.93,2.72,1.52,7.57.24,17.24-2.11,15.99-28.12,45.01-28.12,45.01,0,0-168.64,199.58-173.38,205.73-4.76,6.17,10.19,5.28,10.19,5.28,0,0,126.26.35,165.3,0,46.07-3.16,51.7-48.89,51.7-48.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1123.59,664.13c-27.68,0-50.11,22.86-50.11,51.06,0,22.16,30.94,62.69,44.19,79.04,3.08,3.79,8.77,3.79,11.83,0,13.27-16.35,44.2-56.88,44.2-79.04,0-28.2-22.45-51.06-50.12-51.06ZM1143.54,721.92c-6.28,6.93-18.01,16.06-19.95,17.55-.05.04-.1.07-.14.11-.04-.04-.09-.07-.14-.11-1.94-1.49-13.66-10.62-19.94-17.55-6.86-7.56-5.8-21.8,5.98-24.26,10.29-2.15,13.46,3.35,14.1,4.77.64-1.42,3.81-6.93,14.11-4.77,11.78,2.47,12.83,16.7,5.98,24.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st54",
    x: 1118.9,
    y: 608.7,
    width: 9.32,
    height: 32.36,
    rx: 3.74,
    ry: 3.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st54",
    x: 1078.81,
    y: 621.51,
    width: 9.32,
    height: 32.36,
    rx: 3.74,
    ry: 3.74,
    transform: "translate(-133.57 952.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st54",
    x: 1159,
    y: 621.51,
    width: 9.32,
    height: 32.36,
    rx: 3.74,
    ry: 3.74,
    transform: "translate(1535.57 1911.42) rotate(-135)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M925.7,833.43h125.14v275.46c0,9.25-7.51,16.77-16.77,16.77h-108.37v-292.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M925.7,854.18s13.73,3.62,18.6-6.28c8.03,8.21,18.23,12.54,31.07.88,9.67,9.09,23.74,9.2,31.65-.88,6.15,7.51,22.68,9.2,30.6,0,5.1,5.93,13.22,6.63,13.22,6.63v-23.04h-125.14s-.22,22.9,0,22.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M945.75,745.44h90.66c7.06,0,12.79,5.73,12.79,12.79v4.63h-116.23v-4.63c0-7.06,5.73-12.79,12.79-12.79Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "1066.55 823.11 1036.79 823.11 1024.77 762.86 1049.2 762.86 1066.55 823.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "1036.79 823.11 1006.06 823.11 1001.68 762.86 1024.77 762.86 1036.79 823.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "1006.06 823.11 976.56 823.11 978.45 762.86 1001.68 762.86 1006.06 823.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "978.45 762.86 976.56 823.11 944.3 823.11 955.83 762.86 978.45 762.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "955.83 762.86 944.3 823.11 915.56 823.11 933.14 762.86 955.83 762.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M915.56,823.11h28.74v12.03c0,6.37-5.17,11.53-11.53,11.53h-5.67c-6.37,0-11.53-5.17-11.53-11.53v-12.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M1036.79,823.11h29.76v12.03c0,6.37-5.17,11.53-11.53,11.53h-6.69c-6.37,0-11.53-5.17-11.53-11.53v-12.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M976.56,823.11h29.51v12.03c0,6.37-5.17,11.53-11.53,11.53h-6.44c-6.37,0-11.53-5.17-11.53-11.53v-12.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1006.06,823.11h30.73v12.03c0,6.37-5.17,11.53-11.53,11.53h-7.66c-6.37,0-11.53-5.17-11.53-11.53v-12.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M944.3,823.11h32.26v11.84c0,7.15-5.8,12.95-12.95,12.95h-6.36c-7.15,0-12.95-5.8-12.95-12.95v-11.84h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M953.35,862.74h71.8c5.16,0,9.35,4.19,9.35,9.35v109.28h-90.5v-109.28c0-5.16,4.19-9.35,9.35-9.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M980.52,920.1s-.73,4.66-4,6.17c3.52,8.89,13.81,11.27,19.93,7.83,3.19-1.93,5.66-7.83,5.66-7.83,0,0-3.39,1.21-4.06-6.67-5.05,4.39-17.52.5-17.52.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M968.86,898.06s-3.74-9.61,1.56-18.17c5.31-8.55,16.82-9.45,23.25-8.66s9.28,5.31,9.28,5.31c0,0,4.58.39,6.87,6.43s-.28,15.76-.28,15.76l-2.35,2.07-8.72-8.1s-12.41-.67-13.08-.5-6.71,1.9-6.93,2.24-1.51,5.14-2.4,5.76-3.74,2.4-4.3,2.52-3.8-.45-3.8-.45l.89-4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M971.34,899.52s-.25-2.18-2.47-1.47-3.65,4.32-1.84,8.26c1.8,3.94,4.99,3.48,4.99,3.48,0,0,1.59,6.92,7.08,10.69,5.49,3.77,9.26,4.32,15.55,2.52s10.94-7.88,11.74-13.33c2.35.29,6.16-2.26,6.04-7.04-.13-4.78-3.23-5.02-4.11-4.71s-.21,1.84-1.3,1.78c-.8-.04-1.84-4.57-2.6-6.33s-3.27-6.12-3.27-6.12c0,0-2.22,2.56-10.98,2.56s-11.19-2.93-11.19-2.93c0,0-2.39,1.26-4.36,5.74-1.97,4.49-1.63,5.16-2.01,6.2s-.8,1.97-1.26.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 981.48,
    cy: 900.44,
    rx: 2.56,
    ry: 3.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 997.49,
    cy: 900.44,
    rx: 2.56,
    ry: 3.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 989.35,
    cy: 906.95,
    rx: 2.32,
    ry: 1.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M995.61,912.11c-.51.93-1.28,1.92-2.62,2.6-.95.48-2.18.81-3.81.87-1.37.05-2.47-.29-3.33-.79-1.61-.94-2.39-2.46-2.53-3.09-.22-.98.73-.77.73-.77,0,0,.28.06.8.14.92.14,2.57.34,4.69.38,2.17.04,3.61-.18,4.55-.31.5-.07.86-.12,1.11-.1.73.05.67.31.42,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M994.08,911.13c-.06.27-.18.71-.35.82-.25.17-1.15.59-4.67.53-3.52-.06-3.77-.14-4.14-.64-.23-.32-.17-.6-.09-.77.92.14,2.57.34,4.69.38,2.17.04,3.61-.18,4.55-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M992.99,914.71c-.95.48-2.18.81-3.81.87-1.37.05-2.47-.29-3.33-.79.73-.7,2.07-1.17,3.61-1.17s2.78.43,3.53,1.09Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M949.88,959.86s2.05-14.48,6.51-21.75,14.24-9.38,14.24-9.38l-.06,21.45-7.68,27.26-9.32-3.81-3.69-13.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "946.89 975.75 949.88 959.86 966.05 959.86 962.89 977.45 946.89 975.75"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1028.3,959.86s-2.05-14.48-6.51-21.75c-4.45-7.27-14.24-9.38-14.24-9.38l.06,21.45,7.68,27.26,9.32-3.81,3.69-13.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "1031.29 975.75 1028.3 959.86 1012.12 959.86 1015.29 977.45 1031.29 975.75"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "970.63 928.74 976.52 926.28 976.52 947.03 1002.1 947.03 1002.1 926.28 1007.55 928.74 1007.55 950.19 1015.29 977.45 962.54 977.45 970.57 950.19 970.63 928.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M976.52,926.28s3.19,8.94,12.1,8.65,11.14-3.31,13.48-8.65v20.75h-25.59v-20.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 935.63,
    y: 975.75,
    width: 105.27,
    height: 15.47,
    rx: 6.21,
    ry: 6.21
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1211.18,833.43h125.14v275.46c0,9.25-7.51,16.77-16.77,16.77h-108.37v-292.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1211.18,854.18s13.73,3.62,18.6-6.28c8.03,8.21,18.23,12.54,31.07.88,9.67,9.09,23.74,9.2,31.65-.88,6.15,7.51,22.68,9.2,30.6,0,5.1,5.93,13.22,6.63,13.22,6.63v-23.04h-125.14s-.22,22.9,0,22.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M1231.23,745.44h90.66c7.06,0,12.79,5.73,12.79,12.79v4.63h-116.23v-4.63c0-7.06,5.73-12.79,12.79-12.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "1352.03 823.11 1322.27 823.11 1310.25 762.86 1334.68 762.86 1352.03 823.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "1322.27 823.11 1291.54 823.11 1287.16 762.86 1310.25 762.86 1322.27 823.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "1291.54 823.11 1262.04 823.11 1263.93 762.86 1287.16 762.86 1291.54 823.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "1263.93 762.86 1262.04 823.11 1229.78 823.11 1241.31 762.86 1263.93 762.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "1241.31 762.86 1229.78 823.11 1201.04 823.11 1218.62 762.86 1241.31 762.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1201.04,823.11h28.74v12.03c0,6.37-5.17,11.53-11.53,11.53h-5.67c-6.37,0-11.53-5.17-11.53-11.53v-12.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1322.27,823.11h29.76v12.03c0,6.37-5.17,11.53-11.53,11.53h-6.69c-6.37,0-11.53-5.17-11.53-11.53v-12.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1262.04,823.11h29.51v12.03c0,6.37-5.17,11.53-11.53,11.53h-6.44c-6.37,0-11.53-5.17-11.53-11.53v-12.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1291.54,823.11h30.73v12.03c0,6.37-5.17,11.53-11.53,11.53h-7.66c-6.37,0-11.53-5.17-11.53-11.53v-12.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1229.78,823.11h32.26v11.84c0,7.15-5.8,12.95-12.95,12.95h-6.36c-7.15,0-12.95-5.8-12.95-12.95v-11.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1239.32,862.74h71.89c5.2,0,9.42,4.22,9.42,9.42v111.32h-90.74v-111.32c0-5.2,4.22-9.42,9.42-9.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1257.74,929.82s-8.49-1.14-10.04-5.8c-1.55-4.65,1.39-7.29,1.71-8.79s2.04-24.93,8.33-33.34,14.53-10.37,18.45-8.82c3.51-1.71,12.57,1.55,16.82,7.59,4.25,6.04,5.31,10.04,6.29,18.86s1.63,14.61,3.1,17.06c1.47,2.45,1.88,5.72,0,8.57-1.88,2.86-8.16,3.35-8.16,3.35,0,0-3.76-.33-8.25-1.47-2.45-.98-2.8-5.91-2.8-5.91,0,0,6.4-3.8,7.21-12.3s-2.37-11.27-2.37-11.27l-11.59-5.88-8.82,2.53-5.96,3.92-3.02,6.84,10.12,9.81-1.14,5.8s.49,3.51,0,4.98-2.86,2.37-2.86,2.37l-7.02,1.88Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1267.62,920.59s.9,4.57-2.86,7.35c1.63,5.96,7.02,7.76,12.74,7.1,5.72-.65,8.57-5.06,8.49-8-2.2-.33-2.75-3.84-2.8-7.76-3.32,1.22-14.44,1.41-15.57,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M1258.72,899.36s-1.74-1.58-3.7,0-1.31,5.72,0,7.89,3.97,2.12,3.97,2.12c0,0,.93,5.88,5.82,9.85s8.16,4.03,10.89,4.3,8.16-1.85,12.41-6.42c2.99-3.32,3.54-8,3.54-8,0,0,2.56.93,4.68-2.78,2.12-3.7,0-6.9-.87-7.67s-2.94.7-2.94.7c0,0-.54.27-1.69-3.27-4.19-.33-10.4-5.44-14.86-9.69-5.28,6.15-13.01,7.89-15.13,9.31s-2.12,3.65-2.12,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M1271.07,910.74s-2.18-.6-1.36,1.47,2.5,3.48,6.86,2.88,4.95-4.24,4.74-4.44-1.52.68-3.21.95-5.39.6-7.02-.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st53",
    cx: 1267.62,
    cy: 901.82,
    rx: 2.48,
    ry: 2.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st53",
    cx: 1283.18,
    cy: 901.82,
    rx: 2.48,
    ry: 2.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st45",
    cx: 1275.37,
    cy: 907.53,
    rx: 2.25,
    ry: 1.67
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M1233.24,976.48s4.16-24.98,8.82-34.54,9.31-12.49,15.43-12.12c-1.22,9.68-1.35,18.25-1.35,18.25l-6,29.64-16.9-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M1318.12,976.48s-4.16-24.98-8.82-34.54c-4.65-9.55-9.01-12.49-15.13-12.12,1.22,9.68,1.05,18.25,1.05,18.25l6,29.64,16.9-1.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1263.23,928.35l1.53-.41s2.16,7.92,11.23,6.73c9.06-1.18,10-7.63,10-7.63l2.97.53v21.72h-28.15l2.43-20.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1256.48,929.59l6.75-1.24v18.13h24.76v-20.41l6.37,1.17.61,21.33s5.02,25.96,5.88,30.01h-51.44l6.98-31.11.09-17.87Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "st47",
    x: 1223.39,
    y: 974.98,
    width: 104.45,
    height: 16,
    rx: 6.42,
    ry: 6.42
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1153.74,1031.09h-7.96s-4.52-12.8-12.53-22.83c-1.14.9-2.58,1.44-4.16,1.44-1.69,0-3.23-.62-4.4-1.64-8.11,10.05-12.68,23.03-12.68,23.03h-7.96s4.99-8.91,9.27-16.75c4.27-7.86,9.12-11.19,9.12-11.19,0-3.62,2.97-6.55,6.64-6.55s6.64,2.93,6.64,6.55c0,.1,0,.19-.01.29,1.21.95,5.17,4.35,8.74,10.9,4.28,7.85,9.27,16.75,9.27,16.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st41",
    x: 1088,
    y: 1028.29,
    width: 81.8,
    height: 78.54,
    rx: 4.85,
    ry: 4.85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1145.19,1088.95h-32.82s-4.04-.59-3.68-4.46c.35-3.86,3.68-28.49,3.68-28.49h32.82s3.33,24.62,3.69,28.49c.35,3.87-3.69,4.46-3.69,4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1139.13,1052.14v3.86h-4.13c.09-.42.14-.86.14-1.31v-1.49c0-1.78-.73-3.39-1.92-4.56-1.19-1.16-2.82-1.88-4.62-1.88-3.61,0-6.54,2.88-6.54,6.44v1.49c0,.45.05.88.14,1.31h-3.98v-3.86c0-5.7,4.67-10.31,10.46-10.31,2.88,0,5.51,1.16,7.39,3.01s3.07,4.45,3.07,7.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1211.57,912.93v111.13c-6.92-37.34-40.11-65.67-79.99-65.67s-75.95,30.84-80.75,70.61v-116.07h160.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M1133.88,888.59s1.78-24.79-9.1-30.6c-10.88-5.8-20.51,12.13-20.51,21.98s3.03,18.46,3.03,18.46l26.57-.7v-9.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1159.38,888.59s2.5-18.11-4.46-20.57c-6.96-2.46-17.66,6.33-21.04,16.88v12.84l24.61.7.89-9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M1153.74,897.73s5.11-17.76,19.55-22.16c14.45-4.4,17.3,6.68,13.55,11.08-3.75,4.4-11.24,11.08-11.24,11.08h-21.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1106.77,879.09s-6.96-18.11-20.87-19.69c-13.91-1.58-10.52,15.94-6.96,23.62,3.57,7.68,17.66,17.18,17.66,17.18l10.7-1.76,2.85-5.28-3.39-14.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1164.02 894.85 1171.87 886.94 1174.13 887.82 1165.63 896.09 1164.02 894.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1137.63 897.67 1137.63 893.97 1145.83 884.3 1144.05 896.96 1137.63 897.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1113.73 898.32 1117.47 877.09 1118.37 899.95 1113.73 898.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1106.42 897.67 1092.98 874.98 1099.7 898.72 1106.42 897.67"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M1079.13,901.42s-3.39,3.78,1.43,11.5h101.12s2.71-4,1.43-11.5h-103.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st51",
    x: 1074.61,
    y: 893.92,
    width: 112.24,
    height: 10.55,
    rx: 3.98,
    ry: 3.98
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1352.93,1069.59s25.85-4.75,37.45-22.51c11.61-17.76,5.8-22.68-4.92-23.56-10.73-.88-30.95,9.5-39.21,29.01-3.08,10.9,0,18.64,0,18.64l6.68-1.58Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1348.18,1067.83s4.4-17.41,21.8-26.2c-12.84,14.24-19.17,26.2-19.17,26.2h-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1336.93,1029.67s-10.2-20.4-25.15-22.51c-14.95-2.11-13.01,21.8-3.52,36.05,9.5,14.24,21.28,18.99,23.39,27.08,5.63.88,8.79-1.06,8.79-1.06l8.62-40.44s17.76-2.81,26.73-22.68c8.97-19.87,11.08-28.66,5.1-36.4s-24.27.88-34.64,16.71-10.37,36.4-9.32,43.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1338.16,1067.83s-3.87-24.27-15.65-37.28c7.03,20.4,12.31,38.69,12.31,38.69l3.34-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1348.18,1067.83s-5.1-40.27,12.48-72.62c-18.11,19.17-23.74,59.96-20.22,74.03,5.63,4.04,7.74-1.41,7.74-1.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1371.39,1082.25s-.09,1.1-.26,2.93l-.04.47-.12,1.36-.22,2.45-.04.35c-.75,7.73-2.02,19.46-3.35,25.5-2.12,9.49-10.91,10.35-10.91,10.35h-22.68c-5.46,0-9.84,1.08-13.71-7.88-2.63-6.09-4.04-19.79-4.67-27.96-.14-1.89-.25-3.5-.32-4.63-.06-1.18-.1-1.87-.1-1.87l56.44-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1371.13,1085.18l-.04.47-.12,1.36-.22,2.45-.04.35h-55.33c-.14-1.89-.25-3.5-.32-4.63h56.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1310.2,
    y: 1067.83,
    width: 65.59,
    height: 17.58,
    rx: 3.7,
    ry: 3.7
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZinihubIconRoundEdge);
export default __webpack_public_path__ + "static/media/zinihub_icon_RoundEdge.fcbb72c64dce6e2b1fdde8e11cb5ed25.svg";
export { ForwardRef as ReactComponent };